module.exports = __webpack_public_path__ + "static/media/1.2 Erper Detail Reduz. Festigungsmittel_klein.cb905f39.jpg";